import { render, staticRenderFns } from "./TeacherModal.vue?vue&type=template&id=e877512c&scoped=true&"
import script from "./TeacherModal.vue?vue&type=script&lang=js&"
export * from "./TeacherModal.vue?vue&type=script&lang=js&"
import style0 from "./TeacherModal.vue?vue&type=style&index=0&id=e877512c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e877512c",
  null
  
)

export default component.exports